var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudioTranscription(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AudioTranscription"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.33333 9.50861C9.5981 9.50861 10.619 8.52124 10.619 7.29808V2.87703C10.619 1.65387 9.5981 0.666504 8.33333 0.666504C7.06857 0.666504 6.04762 1.65387 6.04762 2.87703V7.29808C6.04762 8.52124 7.06857 9.50861 8.33333 9.50861ZM7.57143 2.87703C7.57143 2.47177 7.91429 2.14019 8.33333 2.14019C8.75238 2.14019 9.09524 2.47177 9.09524 2.87703V7.29808C9.09524 7.70335 8.75238 8.03493 8.33333 8.03493C7.91429 8.03493 7.57143 7.70335 7.57143 7.29808V2.87703ZM12.1429 7.29808C12.1429 9.33177 10.4362 10.9823 8.33333 10.9823C6.23048 10.9823 4.52381 9.33177 4.52381 7.29808H3C3 9.89914 4.98857 12.036 7.57143 12.397V14.6665H9.09524V12.397C11.6781 12.036 13.6667 9.89914 13.6667 7.29808H12.1429Z",
    fill: "#45657B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioTranscription);
export default __webpack_public_path__ + "static/media/AudioTranscription.07bfc9c963befe7c1a75829cda61531d.svg";
export { ForwardRef as ReactComponent };